var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"50de8756"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the intialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

if (!process.env.SENTRY_DISABLE) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
    environment: process.env.SENTRY_ENVIRONMENT,
    autoSessionTracking: false,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    denyUrls: [/shared-api\//i, /carrotquest/i, /^chrome:\/\//i],
    ignoreErrors: [/currentTimestamp/, /carrotquest/, /autoEvents/],
  });
}
